<template>
  <router-link
    :to="{ name: '/cart' }"
    class="relative flex bg-[initial] xl:p-0 justify-center items-center rounded-[5px] p-1 w-[32px] h-[32px] xl:w-[70px] md:w-[44px] md:h-[44px] hover:text-secondary"
    :class="{ active: $route.name === '/cart' }"
  >
    <div
      class="items-center gap-[4px] md:flex justify-center w-[24px] h-[24px] md:w-[32px] md:h-[32px] active:text-secondary-pressed hover:text-secondary text-[#242D21]"
      :class="{ active: $route.name === '/cart' }"
    >
      <icon-cart
        class="shrink-0 relative text-[20px]"
        :class="{ active: $route.name === '/cart' }"
      ></icon-cart>
      <span class="xl:block hidden text-[18px] font-medium" :class="{ active: $route.name === '/cart' }">
        {{ $t("common.cart") }}
      </span>
    </div>
    <div
      v-if="cartStore.getProductsList.length > 0"
      class="absolute md:w-[20px] md:h-[20px] w-[14px] h-[14px] top-[0] right-[0] left-[63%] overflow-hidden flex justify-center items-center text-[12px] font-normal font-Montserrat text-white bg-[#FF507F] rounded-full xl:left-[15px]"
    >
      {{ cartStore.getProductsList.length }}
    </div>
  </router-link>
</template>

<script setup lang="ts">
import IconCart from "@/components/icons/IconCart.vue"
import { useCartProducts } from "@/stores/use-cart-products"

const cartStore = useCartProducts()
</script>
